/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NaturePlantTreeAIcon16Light } from './NaturePlantTreeAIcon16Light';
import { NaturePlantTreeAIcon16Regular } from './NaturePlantTreeAIcon16Regular';
import { NaturePlantTreeAIcon16Solid } from './NaturePlantTreeAIcon16Solid';
import { NaturePlantTreeAIcon20Light } from './NaturePlantTreeAIcon20Light';
import { NaturePlantTreeAIcon20Regular } from './NaturePlantTreeAIcon20Regular';
import { NaturePlantTreeAIcon20Solid } from './NaturePlantTreeAIcon20Solid';
import { NaturePlantTreeAIcon24Regular } from './NaturePlantTreeAIcon24Regular';
import { NaturePlantTreeAIcon24Solid } from './NaturePlantTreeAIcon24Solid';
import { NaturePlantTreeAIcon32Regular } from './NaturePlantTreeAIcon32Regular';
import { NaturePlantTreeAIcon64Regular } from './NaturePlantTreeAIcon64Regular';
var sizes = {
    16: {
        light: NaturePlantTreeAIcon16Light,
        regular: NaturePlantTreeAIcon16Regular,
        solid: NaturePlantTreeAIcon16Solid,
    },
    20: {
        light: NaturePlantTreeAIcon20Light,
        regular: NaturePlantTreeAIcon20Regular,
        solid: NaturePlantTreeAIcon20Solid,
    },
    24: {
        regular: NaturePlantTreeAIcon24Regular,
        solid: NaturePlantTreeAIcon24Solid,
    },
    32: {
        regular: NaturePlantTreeAIcon32Regular,
    },
    64: {
        regular: NaturePlantTreeAIcon64Regular,
    },
};
export var NaturePlantTreeAIcon = forwardRef('NaturePlantTreeAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
